import PropTypes from 'prop-types';
import { TableCell } from '@mui/material';

const AcTableCell = ({hasAC, hasDC, data, header}) => {
  if (hasAC) {
    return <TableCell align={hasDC ? "left" : "right"} sx={{fontWeight: header ? 'bold' : 'normal'}}>{data}</TableCell>
  }
  return null;
}

export default AcTableCell;

AcTableCell.propTypes = {
  hasAC: PropTypes.bool,
  hasDC: PropTypes.bool, 
  data: PropTypes.any,
  header: PropTypes.bool,
}